import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/app/[locale]/(public)/blog/bebauungsplan/BlogContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/components/shared/public/BlogIntlProvider.tsx");
